import apiClient from "../api/apiClient"
import { endPoints } from "../config/endpoints";

export const tripUnavailableDateService = {
  async getAsync(tripId) {
    const response = await apiClient.get(
      `${endPoints.tripUnavailableDate.get}/${tripId}`,
    );
    return response.data;
  },
 
  async deleteAsync(tripUnavailableDateId) {
    const response = await apiClient.delete(
      `${endPoints.tripUnavailableDate.delete}/${tripUnavailableDateId}`,
    );
    return response.data;
  },
  async createAsync(tripId, date) {
    const response = await apiClient.post(
      `${endPoints.tripUnavailableDate.create}/${tripId}`,
      date,
      {
        headers: { "Content-Type": "application/json" },
      },
    );
    return response.data;
  },
};